const LOOK_A_LIKE_FEATURE_FLAG_PROPS = Object.freeze({
  allowChangeFilters: { type: Boolean, default: true },
  allowPresets: { type: Boolean, default: true },
  allowRedirectToSearch: { type: Boolean, default: false },
  isAddable: { type: Boolean, default: false },
  isClickable: { type: Boolean, default: true },
  isFilterable: { type: Boolean, default: true },
  isHeaderChangeable: { type: Boolean, default: true },
  showSelect: { type: Boolean, default: false },
  withDefaultFooter: { type: Boolean, default: false },
  withTotalHits: { type: Boolean, default: false },
  allowColumnModeSwitch: { type: Boolean, default: true }
});

export default LOOK_A_LIKE_FEATURE_FLAG_PROPS;
